import { render, staticRenderFns } from "./bindingMobile.vue?vue&type=template&id=07849890&scoped=true"
import script from "./bindingMobile.vue?vue&type=script&lang=js"
export * from "./bindingMobile.vue?vue&type=script&lang=js"
import style0 from "./bindingMobile.vue?vue&type=style&index=0&id=07849890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07849890",
  null
  
)

export default component.exports